import CurrentTime from './currentTime';

export default CurrentTime;
